module.exports = "/static/assets/ccad5b82466a7542b58231b056b7a377.png";